import { render, staticRenderFns } from "./FaFincialNumber.vue?vue&type=template&id=15bc5d5a&scoped=true&"
import script from "./FaFincialNumber.vue?vue&type=script&lang=ts&"
export * from "./FaFincialNumber.vue?vue&type=script&lang=ts&"
import style0 from "./FaFincialNumber.vue?vue&type=style&index=0&id=15bc5d5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bc5d5a",
  null
  
)

export default component.exports